{
  "$id": "wealthlane://forms/job-scheduler",
  "$schema": "wealthlane://schemas/form-model",
  "domain": "../job-scheduler.domain.json",
  "dataSource": {
    "submit": {
      "actionId": "SAVE_JOB_SCHEDULER",
      "invalidateQueries": ["getJobSchedules"],
      "successMessage": "Schedule saved successfully."
    }
  },
  "properties": {
    "id": { "$ref": "module://job-scheduler#properties/id" },
    "name": { "$ref": "module://job-scheduler#properties/name", "required": true },
    "description": {
      "$ref": "module://job-scheduler#properties/description"
    },
    "recurrenceStartDate": {
      "$ref": "module://job-scheduler#properties/recurrenceStartDate",
      "required": true
    },
    "recurrenceStartTime": {
      "$ref": "module://job-scheduler#properties/recurrenceStartTime",
      "required": true
    },
    "recurrenceStartWeekdayHint": {
      "$ref": "module://job-scheduler#properties/recurrenceStartWeekdayHint",
      "hiddenWhen": { "field": "recurrenceStartWeekdayHint", "isEmpty": true }
    },
    "recurrenceTypeId": {
      "$ref": "module://job-scheduler#properties/recurrenceTypeId",
      "required": true,
      "actionId": "FETCH_JOB_SCHEDULER_RECURRENCE_TYPES",
      "disabledWhen": {
        "anyOf": [
          { "field": "recurrenceStartDate", "isEmpty": true },
          { "field": "recurrenceStartTime", "isEmpty": true }
        ]
      }
    },
    "recurrenceDisplayText": {
      "$ref": "module://job-scheduler#properties/recurrenceDisplayText",
      "hiddenWhen": { "field": "recurrenceDisplayText", "isEmpty": true }
    },
    "recurrenceInstructionsJson": {
      "type": "object",
      "properties": {
        "timeZone": {
          "$ref": "module://job-scheduler#properties/timeZone",
          "required": true,
          "actionId": "FETCH_JOB_SCHEDULER_TIMEZONE_OPTIONS"
        },
        "cronExpression": {
          "$ref": "module://job-scheduler#properties/cronExpression"
        },
        "customRecurrenceInstructionsJson": {
          "type": "object",
          "widget": "hidden",
          "properties": {
            "repeatEvery": { "$ref": "module://job-scheduler#properties/repeatEvery" },
            "repeatUnit": { "$ref": "module://job-scheduler#properties/repeatUnit" },
            "repeatOnDays": { "$ref": "module://job-scheduler#properties/repeatOnDays" },
            "endType": { "$ref": "module://job-scheduler#properties/endType" },
            "endOn": { "$ref": "module://job-scheduler#properties/endOn" },
            "occurrencesLimit": { "$ref": "module://job-scheduler#properties/occurrencesLimit" }
          }
        }
      }
    },
    "taskTypeId": {
      "$ref": "module://job-scheduler#properties/taskTypeId",
      "required": true,
      "actionId": "FETCH_JOB_SCHEDULER_TASK_TYPES"
    },
    "taskDetailsName": { "$ref": "module://job-scheduler#properties/taskDetailsName" },
    "taskInstruction": {
      "type": "object",
      "properties": {
        "taskDetailId": {
          "$ref": "module://job-scheduler#properties/taskDetailId",
          "required": true,
          "actionId": "FETCH_JOB_SCHEDULER_CUSTOM_REPORTS",
          "dependsOn": ["taskTypeId"],
          "paramMap": { "taskTypeId": "taskTypeId" },
          "hiddenWhen": {
            "field": "taskDetailsName",
            "notEquals": "Dynamic Report"
          },
          "disabledWhen": { "field": "taskTypeId", "isEmpty": true }
        },
        "taskDetailsName": {
          "$ref": "module://job-scheduler#properties/taskDetailsName"
        },
        "taskExecutionDto": {
          "type": "object",
          "properties": {
            "awardTypeId": {
              "$ref": "module://job-scheduler#properties/awardTypeId",
              "required": true,
              "actionId": "FETCH_JOB_SCHEDULER_RELEASE_AWARD_TYPES",
              "hiddenWhen": {
                "field": "taskDetailsName",
                "notEquals": "Release Automation"
              }
            },
            "grantIds": {
              "$ref": "module://job-scheduler#properties/grantIds",
              "actionId": "FETCH_JOB_SCHEDULER_GRANT_OPTIONS",
              "dependsOn": [
                "taskInstruction.taskDetailsName",
                "taskInstruction.taskExecutionDto.awardTypeId"
              ],
              "paramMap": {
                "taskDetailsName": "taskDetailsName",
                "awardTypeId": "taskInstruction.taskExecutionDto.awardTypeId"
              },
              "hiddenWhen": {
                "not": {
                  "field": "taskDetailsName",
                  "in": ["Release Automation", "Exercise Automation"]
                }
              },
              "disabledWhen": {
                "allOf": [
                  { "field": "taskDetailsName", "equals": "Release Automation" },
                  { "field": "taskInstruction.taskExecutionDto.awardTypeId", "isEmpty": true }
                ]
              }
            },
            "settlementTypeIds": {
              "$ref": "module://job-scheduler#properties/settlementTypeIds",
              "actionId": "FETCH_SETTLEMENT_TYPES",
              "hiddenWhen": {
                "not": {
                  "field": "taskDetailsName",
                  "in": ["Release Automation", "Exercise Automation"]
                }
              }
            },
            "timeInterval": {
              "$ref": "module://job-scheduler#properties/timeInterval",
              "required": true,
              "hiddenWhen": {
                "not": {
                  "field": "taskDetailsName",
                  "in": ["Release Automation", "Exercise Automation"]
                }
              }
            },
            "configuration": {
              "$ref": "module://job-scheduler#properties/configuration",
              "required": true,
              "minItems": 1,
              "actionId": "FETCH_JOB_SCHEDULER_AUTOMATION_CONFIGURATION",
              "paramMap": {
                "taskDetailsName": "taskDetailsName"
              },
              "hiddenWhen": {
                "not": {
                  "field": "taskDetailsName",
                  "in": ["Release Automation", "Exercise Automation"]
                }
              }
            },
            "id": {
              "$ref": "module://job-scheduler#properties/taskExecutionDtoId"
            },
            "reportName": {
              "$ref": "module://job-scheduler#properties/reportName"
            },
            "taskDetailsName": {
              "$ref": "module://job-scheduler#properties/taskDetailsName"
            }
          }
        },
        "responseDetails": {
          "$ref": "module://job-scheduler#properties/responseDetails"
        }
      }
    },
    "OPEN_REPORT_DESIGNER": {
      "$ref": "module://job-scheduler#properties/OPEN_REPORT_DESIGNER",
      "passFormData": true,
      "hiddenWhen": {
        "anyOf": [
          { "field": "taskDetailsName", "notEquals": "Dynamic Report" },
          { "field": "taskInstruction.taskExecutionDto.id", "isEmpty": true }
        ]
      }
    }
  },
  "modes": {
    "create": {
      "lifecycle": {
        "submitBehavior": "close",
        "externalPatchBus": true
      }
    },
    "edit": {
      "dataSource": {
        "fetch": {
          "actionId": "GET_JOB_SCHEDULER_FOR_EDIT",
          "params": { "id": "{params.id}" }
        }
      },
      "lifecycle": {
        "submitBehavior": "close",
        "externalPatchBus": true
      }
    },
    "view": {
      "viewPresentation": "disabled-inputs",
      "dataSource": {
        "fetch": {
          "actionId": "GET_JOB_SCHEDULER_FOR_EDIT",
          "params": { "id": "{params.id}" }
        }
      }
    }
  }
}
